package org.lennycodes.hldi.pages
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.components.GalleryGrid
import org.lennycodes.hldi.constants.HLDITheme
import org.lennycodes.hldi.data.GalleryImage
import org.lennycodes.hldi.layouts.MainLayout
import org.lennycodes.hldi.pages.admin.AdminRepository
import org.lennycodes.hldi.styles.AboutHeroSectionStyle
import org.lennycodes.hldi.styles.AboutHeroTextStyle
import org.lennycodes.hldi.styles.AboutHeroTitleStyle
import org.lennycodes.hldi.styles.SectionWaveSvg
import org.lennycodes.hldi.styles.SpinnerStyle

@Composable
@Page("/gallery")
fun GalleryPage() {

    var isLoading by remember { mutableStateOf(true) }

    var galleryImages by remember { mutableStateOf<List<GalleryImage>>(emptyList()) }
    var selectedCategory by remember { mutableStateOf("All") }


    LaunchedEffect(Unit) {

        try {

            galleryImages = AdminRepository.getGalleryImages()

        } finally {

            isLoading = false

        }

    }


    MainLayout {
        // Hero
        Section(
            attrs = Modifier.padding(50.px, 20.px).then( AboutHeroSectionStyle.toModifier())
                .toAttrs()
        ) {
            H1(attrs = AboutHeroTitleStyle.toAttrs()) {
                Text("Gallery")
            }
            P(
                attrs = AboutHeroTextStyle.toAttrs {
                    style { maxWidth(700.px) } // wider than the shared 600px default for this section's longer copy
                }
            ) {
                Text("Moments captured from our humanitarian work across Tanzania.")
            }
            SectionWaveSvg()
        }
        // Category Filter
        Section(
            attrs = Modifier.padding(0.px, 20.px, 40.px)
                .toAttrs()
        ) {
            Div(
                attrs = {
                    style {
                        margin(75.px,32.px,0.px)
                        display(DisplayStyle.Flex)
                        gap(12.px)
                        justifyContent(JustifyContent.Center)
                        flexWrap(FlexWrap.Wrap)
                    }
                }
            ) {
                categories.forEach { category ->
                    Button(
                        attrs = {
                            style {
                                padding(10.px, 24.px)
                                borderRadius(24.px)
                                border(1.px, LineStyle.Solid, HLDITheme.Colors.primary)
                                backgroundColor(
                                    if (selectedCategory == category) HLDITheme.Colors.primary
                                    else HLDITheme.Colors.tranparent
                                )
                                color(
                                    if (selectedCategory == category) HLDITheme.Colors.white
                                    else HLDITheme.Colors.primary
                                )
                                fontSize(14.px)
                                fontWeight(500)
                                cursor(Cursor.Pointer)
                                transition(
                                    transition = Transition.all(
                                        duration = 300.ms,
                                        timingFunction = TransitionTimingFunction.Ease
                                    )
                                )
                            }
                            onClick { selectedCategory = category }
                        }
                    ) {
                        Text(category)
                    }
                }
            }
        }

        // Gallery Grid
        Section {

            val filteredImages = if (selectedCategory == "All")
                galleryImages
            else
                galleryImages.filter { it.category == selectedCategory }


            when {

                isLoading -> {

                    Div(

                        attrs = Modifier
                            .fillMaxWidth()
                            .padding(40.px)
                            .toAttrs {

                                style {

                                    property("display", "flex")

                                    property("justify-content", "center")

                                    property("align-items", "center")

                                }

                            }

                    ) {

                        Div(

                            attrs = Modifier
                                .size(45.px)
                                .then(SpinnerStyle.toModifier())
                                .toAttrs()

                        )

                    }

                }


                filteredImages.isEmpty() -> {

                    P(

                        attrs = {

                            style {

                                textAlign(TextAlign.Center)

                                fontSize(16.px)

                                color(HLDITheme.Colors.mediumGray)

                            }

                        }

                    ) {

                        Text(
                            if (selectedCategory == "All")
                                "No gallery images available yet."
                            else
                                "No gallery images in this category yet."
                        )

                    }

                }


                else -> {

                    GalleryGrid(filteredImages)

                }

            }

        }
    }
}